
import React,{ useState, useContext, useEffect } from 'react';
import NightsStayIcon from '@material-ui/icons/NightsStay';
import WbSunnyIcon from '@material-ui/icons/WbSunny';
import { AuthContext } from '../context/AuthContext';
import { useHistory, Link } from 'react-router-dom';
import '../styles/NavBar.css';

const NavBar = ()=> {

    const [theme, setTheme] = useState(false);
    const { logout, currentUser } = useContext(AuthContext); 
    const [error, setError] = useState("");
    const disabledButton =  currentUser ? false : true;
   // console.log(currentUser===true);
    const history = useHistory();
    
    const changeTheme = () => {
        // if(theme){
        //     document.documentElement.style.setProperty('--background','white');
        // }else{
        //     document.documentElement.style.setProperty('--background','#1b262c');
        // }
        setTheme(prev=>!prev);
    }

    const logoutHandler = async () => {

        try{
            history.push('/');
            await logout();
            history.push("/login");
        }catch(error){
            console.log(error.message);
        }
        
    }

    // useEffect(()=>{
    //     setDisabled(false);
    // },[currentUser])

    return(
        <nav className="navbar">
            <h1>Gallery-App</h1>   
                
            <div className="links">
                {theme?<WbSunnyIcon onClick={changeTheme} style={{color:"orange"}}/>:
                <NightsStayIcon onClick={changeTheme} style={{color:"#151515"}}/>
                } 
            <button className="logout__button" onClick={logoutHandler} disabled = {disabledButton} >logout</button>
            <Link to="/update-profile">
                <button className="logout__button" disabled = {disabledButton} >update profile</button>
            </Link>
            
            

            </div>
            {/* {currentUser && <div><p>{currentUser.email}</p></div>}  */}
        </nav>
        

    );
}

export default NavBar;